export default __webpack_public_path__ + "static/media/playstation.317a34bd.webp";